import { ApiService } from "../../services";
import { Unauthorized } from "../../helpers/unauthorized.handler";


const DEFAULT_DOCUMENT = {
  connection: null,

  DiscPrcnt: 0,
  CardCode: null,
  DocDate: null,
  DocDueDate: null,
  U_WinvoiceNum: null,
  DocumentLines: [],
};

const baseFormRecord = () => ({
  ...DEFAULT_DOCUMENT,
  DocumentLines: [],
});

const normalizeDocumentLines = (lines) => {
  if (!Array.isArray(lines)) return [];

  return lines.map((l) => {
    const line = { ...(l ?? {}) };

    line.ItemCode = String(line.ItemCode ?? "").trim();
    line.Quantity = Number(line.Quantity ?? 0);
    line.WarehouseCode = String(line.WarehouseCode ?? "").trim();

    if (line.U_RefItemId === undefined) line.U_RefItemId = null;
    if (line.BaseEntry !== undefined && line.BaseEntry !== null) {
      line.BaseEntry = Number(line.BaseEntry);
    }
    if (line.BaseLine !== undefined && line.BaseLine !== null) {
      line.BaseLine = Number(line.BaseLine);
    }

    if (Array.isArray(line.BatchNumbers)) {
      line.BatchNumbers = line.BatchNumbers
        .filter((b) => Number(b?.Quantity) > 0 && String(b?.BatchNumber ?? "").trim())
        .map((b) => ({
          BatchNumber: String(b.BatchNumber).trim(),
          Quantity: Number(b.Quantity),
        }));

      if (!line.BatchNumbers.length) delete line.BatchNumbers;
    } else {
      delete line.BatchNumbers;
    }

    return line;
  });
};

const normalizeDocument = (doc) => {
  const next = { ...(doc ?? {}) };

  next.connection = next.connection ?? DEFAULT_DOCUMENT.connection;

  next.DiscPrcnt = Number(next.DiscPrcnt ?? DEFAULT_DOCUMENT.DiscPrcnt);
  next.CardCode = next.CardCode ?? DEFAULT_DOCUMENT.CardCode;

  next.DocDate = next.DocDate ?? DEFAULT_DOCUMENT.DocDate;
  next.DocDueDate = next.DocDueDate ?? DEFAULT_DOCUMENT.DocDueDate;

  next.U_WinvoiceNum = next.U_WinvoiceNum ?? DEFAULT_DOCUMENT.U_WinvoiceNum;

  next.DocumentLines = normalizeDocumentLines(next.DocumentLines);
  if (!next.DocumentLines.length && Array.isArray(next.DocumentLiens)) {
    next.DocumentLines = normalizeDocumentLines(next.DocumentLiens);
  }
  delete next.DocumentLiens;

  return next;
};

function normalizeResponseData(input) {
  return normalizeDocument(input);
}

export const SalesOrderDeliveryModule = {
  namespaced: true,
  state: {
    tblKey: 0,
    getLoading: false,
    viewLoading: false,
    postLoading: false,
    putLoading: false,

    formRecord: baseFormRecord(),
  },

  actions: {
    async getRecord({ state, commit, dispatch }, params) {
      if (state.viewLoading) return;

      commit("setViewLoadingTrue");
      try {
        const response = await ApiService.get(`invoices/${params.series}`, params);
        const responseData = normalizeResponseData(response?.data?.data);

        commit("setTblKey", state.tblKey + 1);
        commit("setFormRecord", responseData);

        return responseData;
      } catch (error) {
        Unauthorized(dispatch, error);
        throw error;
      } finally {
        commit("setViewLoadingFalse");
      }
    },

    async getRecordSeries({ state, commit, dispatch }, params) {
      if (state.viewLoading) return;

      commit("setViewLoadingTrue");
      try {
        const response = await ApiService.get(`invoices/${params.series}`, params);
        const responseData = normalizeResponseData(response?.data?.data);

        commit("setTblKey", state.tblKey + 1);
        commit("setFormRecord", responseData);

        return responseData;
      } catch (error) {
        Unauthorized(dispatch, error);
        throw error;
      } finally {
        commit("setViewLoadingFalse");
      }
    },

    async storeRecord({ state, commit, dispatch }, payload) {
      if (state.postLoading) return;

      commit("setPostLoadingTrue");
      try {
        // Normalize BEFORE sending to guarantee validator compliance
        const requestPayload = normalizeDocument(
          JSON.parse(JSON.stringify(payload))
        );

        const response = await ApiService.store(
          "invoices/make-delivery-note",
          requestPayload
        );

        const responseData = normalizeResponseData(response?.data?.data);
        commit("setFormRecord", responseData);

        return responseData;
      } catch (error) {
        Unauthorized(dispatch, error);
        throw error;
      } finally {
        commit("setPostLoadingFalse");
      }
    },

    async updateRecord({ state, commit, dispatch }, payload) {
      if (state.putLoading) return;

      commit("setPutLoadingTrue");
      try {
        const updatePayload = normalizeDocument(
          JSON.parse(JSON.stringify(payload))
        );

        const response = await ApiService.update("invoices", updatePayload);

        const responseData = normalizeResponseData(response?.data?.data);

        dispatch("getRecordSeries", response?.data?.data);

        return responseData;
      } catch (error) {
        Unauthorized(dispatch, error);
        throw error;
      } finally {
        commit("setPutLoadingFalse");
      }
    },
  },

  mutations: {
    setViewLoadingTrue: (state) => {
      state.viewLoading = true;
    },
    setViewLoadingFalse: (state) => {
      state.viewLoading = false;
    },
    setPostLoadingTrue: (state) => {
      state.postLoading = true;
    },
    setPostLoadingFalse: (state) => {
      state.postLoading = false;
    },
    setPutLoadingTrue: (state) => {
      state.putLoading = true;
    },
    setPutLoadingFalse: (state) => {
      state.putLoading = false;
    },

    setTblKey: (state, payload) => {
      state.tblKey = payload;
    },

    setFormRecord: (state, payload) => {
      state.formRecord = normalizeDocument({
        ...baseFormRecord(),
        ...(payload ?? {}),
      });
    },
  },

  getters: {
    viewLoading: (state) => state.viewLoading,
    postLoading: (state) => state.postLoading,
    putLoading: (state) => state.putLoading,
    formRecord: (state) => state.formRecord,
  },
};
